<template>
	<div class="basis-page-cls">
		<section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" @onSwitch="onSwitch" pageNumber="pageNum" />
		</section>
		<div class="basis-cls_table">
			<div class="header">
				<span class="title el-icon-document"> 数据列表</span>
				<div class="btns">
					<el-button type="primary" size="small" icon="el-icon-circle-plus-outline" class="right" @click="onAdd">新增</el-button>
				</div>
			</div>
			<table-pagination
			v-loading="loading"
			ref="tableItem"
			pagination
			layout="prev,pager,next,total"
			:data="data"
			:column="column"
			:total="total"
			:page.sync="listQuery.pageNum"
			:limit.sync="listQuery.pageSize"
			@pagination="getList"
			/>
		</div>
		<addEdit ref="addEditWords" :options="filterHeader" @getData="getData" :msgTypes="msgTypes"></addEdit>
	</div>
</template>

<script>
	import {EnumMixin} from '@/utils/mixins'
	import addEdit from './addEdit'
	import  { channel } from '@/views/im-channel/data.js'
	import { mapGetters } from "vuex";
	export default {
		components:{
			addEdit
		},
		computed:{
			 ...mapGetters([
				'subBrandList',
				// 'skillGroupLists',
			'userInfo'
			])
		},
		mixins:[EnumMixin],
		data(){
			return {
				filterHeader:[
					{ label: '品牌', model: 'childBrand', type: 'select', default: '', list: [] },
					{ label: '渠道', model: 'channel', type: 'select', default: '', list: channel },
					{ label: '技能组', model: 'skillGroup', type: 'select', default: '', list:[]},
					{ label: '话术类型', model: 'msgTab', type: 'tabs', default: '', list: [{name:'全部',id:''},{name:'节假日话术',id:'holiday'},{name:'系统话术',id:'other'}]},
					{ label: '话术选择', model: 'msgType', type: 'select', default: '', list: [],multiple:true},
				],
				active:0,
				msgTypes:[],//所有话术类型
				listQuery:{
					brand:this.$store.state.user.brandId,
					childBrand:'',
					skillGroup:'',
					pageNum:1,
					pageSize:10,
					msgType:'',//话术id
					msgTab:'',
					channel:''
				},
				loading:false,
				data:[],
				column:[
					{ label: "序号", prop: "index", type: "index" },
					{ label: "品牌", prop: "childBrandName" },
					{ 
						label: "渠道",
						prop: "channel",
						render:(h,scope) => {
							return <span>{this.formatChannel(scope.row)}</span>
						},
					},
					{
						label: "技能组", 
						prop: "skillGroupName",
						render: (h, scope) => {
								return <span>{scope.row.skillGroupName || '--'}</span>
						}
					},
					{ 
						label: "话术类型", 
						prop: "msgType" ,
						render:(h,scope) => {
							return <span>{this.formatMsg(scope.row)}</span>
						},
					},
					{
						label: "话术",
						prop: "holidayMsg",
						render:(h,scope) => {
							return  <el-popover placement="top-start"  width="400"
									trigger="hover"
									content={`${scope.row.holidayMsg}`}>
										<span slot="reference">{scope.row.holidayMsg ? scope.row.holidayMsg.slice(0,4)+'...' : '暂无'}</span>
									</el-popover>

						}
				},
				{
					label: "操作",
					prop: "cation",
					align: "center",
					width: 150,
					fixed:'right',
					render: (h, scope) => {
					return (
						<div class="operate-inline">
						<el-button type="text" size="small" onClick={() => this.onEdit(scope.row)}>
							修改
						</el-button>
						<el-divider direction="vertical"></el-divider>
						<el-button type="text" size="small" onClick={() => this.onDelete(scope.row)}>
							删除
						</el-button>
						</div>
					);
					}
				}
			],
				total:0,
				
			}
		},
		methods:{
			//切换话术类型
			filterSearch(query){
				this.listQuery = Object.assign(this.listQuery, query);
				this.getList();
			},
			onSwitch(val){
				this.listQuery[val.key] = val.data.id;
				this.listQuery.msgType = ''
				switch(val.data.id){
					case 'other':
						this.filterHeader[4].list = this.msgTypes.slice(1);
						break;
					case 'holiday':
						this.filterHeader[4].list = []
						break;
					default:
					this.filterHeader[4].list = this.msgTypes
				}
			},
			onAdd(){
				this.$refs.addEditWords.openAddEdit()
			},
			onEdit(row){
				this.$refs.addEditWords.openAddEdit(row)
			},
			onDelete(row){
				console.log(row)
				this.$confirm("确认要删除该条话术类型记录吗？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "error",
						center: true,
						customClass: "confirm-element-model"
					})
					.then(() => {
						this.$api.deleteSystemWordsListsItem(row.id.split(',')).then(res => {
							if(res.errcode == 0){
								this.$message.success("删除成功")
								this.getList()
							}
						})
						
					})
					.catch(() => {
						this.$message.info('取消删除')
					});
			},
			getList(parmas){
				if(parmas) {
					this.listQuery.pageNum = parmas.page
				}
				this.getData()
			},
			getData(){
				this.loading = true
				const params = JSON.parse(JSON.stringify(this.listQuery));
				params.msgType = []
				if(this.listQuery.msgTab != 'holiday') { 
					if(this.listQuery.msgType) {
						params.msgType = [this.listQuery.msgType]
					}else {
						if(this.listQuery.msgTab == '') {
							params.msgType = []
						}else{
							this.filterHeader[4].list.map(item => {
								params.msgType.push(item.id)
							})
						}
						
					}
				}else {
					params.msgType = ['holiday']
				}
				params.msgType = params.msgType.join(',')
				delete params.msgTab
				this.$api.getSystemWordsLists(params).then(res => {
					this.loading = false
					if(res.errcode == 0) {
						this.data = res.list
						this.total = res.total
					}
				})
			},
			formatMsg(row){
				let result = this.msgTypes.filter(el => el.id == row.msgType)
				if(result.length > 0) return result[0].name
				return'--'
			},
			async getWordsList(){
				await this.$api.getSystemWordsOptions().then(res => {
					this.filterHeader[4]['list'] = res.data;
					this.msgTypes = res.data
				})
			},
		getSkillGroup(){
			this.$api.apiGetSkillGroupLists({brandIdentify: this.userInfo.brandIdentify}).then(response => {
				for(const item of response.data) {
					this.filterHeader[2]['list'].push({
						id: item.skillId,
						name: item.skillName
					});
				}
			});
		}
			
		},
		async created(){
			await this.getData()
			await this.getWordsList();
			await this.getSkillGroup();
			this.filterHeader[0]['list'] = await this.subBrandList;
			// this.filterHeader[2]['list'] = await this.skillGroupLists;
		}
	}
</script>


